import React from 'react';

function Unauthorized() {
  return (
    <div
      style={{ height: '90vh' }}
      className="d-flex justify-content-center align-items-center"
    >
      <div className="text-center">
        <h1 style={{ fontSize: 120 }}>403</h1>
        <h1 className="mt-5">You do not have permissions to view this page.</h1>
      </div>
    </div>
  );
}

export default Unauthorized;
